import React, { useState, useEffect, useContext, useRef } from 'react';
import { PageContext } from './PageContext';
import { UserContext } from './UserContext';
import { Button } from '@progress/kendo-react-buttons';
import { getShareLinkUrl,getAnnotations,getProofNotes, getFormResponses, getFieldsDisplay} from '../services/apiService';
import { Annotorious, OpenSeadragonAnnotator, OpenSeadragonViewer, OpenSeadragonAnnotationPopup, ImageAnnotation, AnnotationState, DrawingStyle, UserSelectAction, useAnnotations, useAnnotator, AnnotoriousOpenSeadragonAnnotator, Annotation, PopupProps, AnnotationBody, User, AnnotoriousContext} from '@annotorious/react';
import { fitBounds } from '@annotorious/openseadragon/dist/api';
import { createOSDAnnotator } from '@annotorious/openseadragon';
import { elements } from '@progress/kendo-react-common';
import OpenSeadragon from 'openseadragon';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck} from '@fortawesome/free-solid-svg-icons';
import { makeLongDate } from './DateTimeHelpers';
import { Grid, GridCellProps, GridColumn } from '@progress/kendo-react-grid';
import { info } from 'logrocket';
import { FormFieldDisplay } from '../services/interfaces';
import { ExpansionPanel, ExpansionPanelActionEvent, ExpansionPanelContent } from '@progress/kendo-react-layout';
import { Reveal } from '@progress/kendo-react-animation';

interface LoaderProps{
    element:string;
    filter:string;
}


const AnnotationLoader=(loaderProps:LoaderProps)=>{
    const annotator = useAnnotator<AnnotoriousOpenSeadragonAnnotator>();
    const [annos, setAnnos] = useState<ImageAnnotation[] | "error">([]);

    useEffect(()=>{
        console.log("Filter Changed" + loaderProps.filter);
        if (annotator){
            getAnnotations(loaderProps.element,loaderProps.filter).then(anno=>{
                console.log(anno);
                setAnnos(anno);                
            });
        }
    },[annotator, loaderProps.filter])

    useEffect(()=>{
        if (annos!="error" && annotator){
            annotator.setAnnotations(annos)
        }
    },[annos])

    return null;
}

function AnnotationUnloader(){
    const annotator = useAnnotator<AnnotoriousOpenSeadragonAnnotator>();
    useEffect(()=>{
        console.log("Unload annotator");
        console.log(annotator);
        annotator.setSelected(undefined);
    },[annotator])
    return null;
}

const AnnotationViewer=React.memo(() => {
    const pageContext = useContext(PageContext);
    const userContext = useContext(UserContext);
    //const myanno = useRef<AnnotoriousOpenSeadragonAnnotator | null>(null);
    const [annotations, setAnnotations] = useState<ImageAnnotation[] | "error">([]);
    const [drawingEnabled,setDrawingEnabled] = useState(true);
    const [annoColor, setAnnoColor]=useState('rgba(255, 0, 0, 1)');
     const annStyle = (annotation: ImageAnnotation, state?: AnnotationState): DrawingStyle => ({
            fill: state?.selected ? ('rgba(0, 167, 84, 1)') : (annoColor as any),
            fillOpacity: 0.25,
        });


    const UserSelect=(a: Annotation): UserSelectAction=>{
        return UserSelectAction.EDIT;
        }

    interface ExtendedPopupProps extends PopupProps {
        readOnly: Boolean
    }
    const CommentPopup = (props: ExtendedPopupProps) => {
        const { annotation, onCreateBody, onUpdateBody } = props;
        const [comment, setComment] = useState('');
        const user:User = {
            name:userContext?.user.fullName||'',
            id:userContext?.user.username||''
        }

        // const onComplete = (e: React.MouseEvent<HTMLButtonElement>) => {
        //     e.preventDefault();
        //     console.log(annotation.id);
        //     const updated:Partial<AnnotationBody> = {
        //     annotation: annotation.id,
        //     purpose: 'commenting',
        //     value: comment,
        //     creator:user
        //     };
        // }

        useEffect(() => {
        if (annotation.bodies){
            const commentBody = annotation.bodies.find(body => body.purpose === 'commenting');
            setComment(commentBody?.value ?? '');
        }
        }, [annotation.bodies]);
            
        return (
        <div>
            <div>{annotation.target.creator?.id}&nbsp;{annotation.target.created?.toDateString()}<br/>{annotation.target.created?.toTimeString()}</div>
            {!props.readOnly? 
                <textarea
                value={comment}
                onChange={e => setComment(e.target.value)} />
            : <p>{comment}</p>
            }
        </div>
        )
    }

    // const createBody=(body:AnnotationBody)=>{
    //     console.log("Create Body");
    //     console.log(body);
    //     if (myanno.current){
    //         var thisAnno = myanno.current.getSelected()[0];
    //         thisAnno.bodies.push(body);
    //         console.log(thisAnno);
    //     }
    // }

    const loadNotes=()=>{
        getAnnotations(pageContext?.selectedAd.element||"","0").then(anno=>{
            setAnnotations(anno);
            console.log("Load Notes");
            setDrawingEnabled(true);
        });
    }

    useEffect(()=>{
        loadNotes();
        return()=>{            
            console.log("Annotation Viewer Unloaded");
        }
    },[])

    useEffect(()=>{
        console.log(annotations);
        if ((annotations ?? []).length>0 && annotations!="error"){
            console.log("setAnnotations");
            //myanno.current?.setAnnotations(annotations, true);
            //console.log(myanno.current?.getAnnotations());
            //console.log(JSON.stringify(myanno.current?.getAnnotations()));
            setDrawingEnabled(false);
        }
    },[annotations]);

    return(
        <Annotorious>
        <OpenSeadragonAnnotator
            //ref={myanno}
            style={annStyle} 
            tool={"rectangle"} 
            drawingEnabled={false}
            drawingMode='click'
            userSelectAction={UserSelectAction.SELECT}
            user={{name:"",id:""}}
        >
            <OpenSeadragonViewer
                //ref={myviewer}
                className='noteImage'
                options={{
                    tileSources:{
                        type:"image",
                        url: pageContext?.proofFiles.thumbURL,
                        ajaxWithCredentials:false,
                    },
                    crossOriginPolicy:"Anonymous",
                    defaultZoomLevel:.5,
                    minZoomLevel:.25,
                    maxZoomLevel:2,
                    gestureSettingsMouse:{clickToZoom:false},
                    prefixUrl:"https://cdn.jsdelivr.net/npm/openseadragon@latest/build/openseadragon/images/"
                }}
            />
            <OpenSeadragonAnnotationPopup
                popup={(props:PopupProps) => (
                    <CommentPopup {...props} readOnly={true} />
            )} />      

        </OpenSeadragonAnnotator>
        <AnnotationLoader element={pageContext?.selectedAd.element||""} filter="0"></AnnotationLoader>
        </Annotorious>
    )
});

interface proofNote{
    time:number
    user_name:string
    operation:string
}

const ProofNotesList=()=>{
    const pageContext=useContext(PageContext);
    const [proofNotes, setProofNotes] = useState<proofNote[]>();

    const formatCell=(e:GridCellProps)=>{
        const time = e.dataItem.time.toString();
        const locale = pageContext?.glSettings.Locale||"en-US"
        const formatTime = makeLongDate(time, locale);        
        return (
            <td>
                {formatTime}
            </td>
        );
    }

    useEffect(()=>{
        if (pageContext){
            getProofNotes(pageContext?.selectedAd.element).then(data=>{
                setProofNotes(data);
            });
        }

    },[])
    
    return(
        <div>
        {proofNotes && proofNotes.length>0?
        <Grid
            className='mt-3' 
            data={proofNotes}                    
        >
            <GridColumn
                field='time'
                title='Date'
                width={"100px"}
                cells={{data:formatCell}}
            />
            <GridColumn title='Operation' field='operation'/>
        </Grid>:null}
        </div>
    );
}

export function Proof(){
    const pageContext = useContext(PageContext);
    const [crtProof, setCrtProof]=useState("");
    const [annotations, setAnnotations] = useState<ImageAnnotation[] | "error">([]);
    const proofType = pageContext?.selectedAd.tmpInt2;
    //const noteViewer = useRef(null);


    const openRMProof=()=>{
        console.log(pageContext?.proofFiles);
        if (pageContext?.proofFiles.rmProof){
            window.open(pageContext.proofFiles.rmProof);
        }
    }

    const getCreatopyProof=()=>{
        const element=pageContext?.selectedAd.slug;
        console.log("Get Creatopy Proof");
        if (element){
            getShareLinkUrl(element).then(data=>{
                console.log(data);
                setCrtProof(data);
            })    
        }    
    }

    interface DisplayFieldData{
        displayLabel:string
        value:string
    }

    const DisplayFields=()=>{
        const [displayData, setDisplayData] = useState<DisplayFieldData[]>([]);
        const element=pageContext?.selectedAd.element;
        const status=pageContext?.selectedAd.status;
        const [expanded,setExpanded]=useState(false);
        useEffect(() => {
            getFormResponses(element).then(responses=>{
                if(responses.length>0){
                    if (status!=""){
                        getFieldsDisplay(status).then((dispFields: FormFieldDisplay[])=>{
                            if (dispFields.length>0){
                                const newDisplayData: DisplayFieldData[] = [];
                                dispFields.forEach((field: FormFieldDisplay) => {
                                    const respItem = responses.find((resp: { fieldID: any; })=>resp.fieldID===field.fieldID)
                                    if (respItem){
                                        newDisplayData.push({displayLabel:field.displayLabel, value:respItem.value});
                                    }
                                });
                                setDisplayData(newDisplayData);
                            }
                        })
                    }
                }
            });
        }, [element, status]);
        
        return displayData.length > 0 ? (
            <ExpansionPanel
                title="Review Text Outside Creative"
                expanded={expanded}
                onAction={(event: ExpansionPanelActionEvent) => {
                    console.log(expanded);
                    setExpanded(!expanded);
                }}
            >  
                <Reveal>
                     {expanded?
                    <ExpansionPanelContent>
                        {displayData.map(item=>(
                            <p key={item.displayLabel}><strong>{item.displayLabel}</strong><br/>{item.value}</p>
                        ))}
                    </ExpansionPanelContent>
                    :null}
                </Reveal>
                
            </ExpansionPanel>
        ) : null;
    }


    const getProof=()=>{
        console.log("ProofType=" + proofType);
        const queue = pageContext?.selectedAd.queue;
        switch (proofType){
            case 0: 
            case undefined:
                return(
                    <div className='noProof'>
                        <img src='/img/noimage.png'/>
                        <p><strong>NO PROOF AVAILABLE</strong></p>
                    </div>                    
                )
            case 1:
            case 11:
                if (window.location.toString().includes("ViewProof")){
                    //read only proof view
                    return(
                        <div id="readOnlyProof" style={{display:"flex", justifyContent:"center", height:"80vh"}}>
                            {queue=="PU-WC"||queue=="PU-CHNG"||queue=="PU CHNG"?<p className="watermarkMsg"style={{color:"darkred"}}><strong>You have requested a PICKUP WITH CHANGES. No changes have been made. Submit your changes by using the CORRECTIONS button or use the APPROVE button to run the ad as-is (without the watermark).</strong></p>:null}
                            {queue=="PU-WC"||queue=="PU-CHNG"||queue=="PU CHNG"?<img className="watermark" style={{height:"inherit"}} src="/img/PUWC.png" />:null}
                            <img id="proofImage" style={{height:"inherit"}} src={pageContext?.proofFiles.thumbURL}/>
                        </div>
                    )    
                }else{
                    //full access view
                    console.log("Proof:" + pageContext?.proofFiles.thumbURL);
                    if (pageContext?.proofFiles.thumbURL==null){
                        //no proof available
                        return(
                            <div className='noProof'>
                                <img src='/img/noimage.png'/>
                                <p><strong>NO PROOF AVAILABLE</strong></p>
                            </div>                    
                        )
                    }else{
                        if (annotations.length>0 && pageContext?.proofFiles.thumbURL){                    
                            return(
                                // <div>
                                //<Annotorious>
                                <AnnotationViewer/>
                                //</Annotorious>
                                // </div>
                            )
                        }else{
                            return(
                                <div id="printProof" >
                                    {queue==="PU-WC"||queue==="PU-CHNG"||queue==="PU CHNG"?<p className="watermarkMsg"style={{color:"darkred"}}><strong>You have requested a PICKUP WITH CHANGES. No changes have been made. Submit your changes by using the CORRECTIONS button or use the APPROVE button to run the ad as-is (without the watermark).</strong></p>:null}
                                    {queue==="PU-WC"||queue==="PU-CHNG"||queue==="PU CHNG"?<img className="watermark" src="/img/PUWC.png" />:null}
                                    <img id="proofImage" src={pageContext?.proofFiles.thumbURL} style={{width:"100%"}}/>
                                </div>
                            )    
                        }
                    }
                }
                

            case 4:
            case 14:
                if (pageContext?.selectedAd.temp6=="Built by Creatopy"){
                    getCreatopyProof();
                    return(
                        <div id="crtProof" >
                            <iframe id="crtProofFrame" src={crtProof} style={{width:"100%",height:"88vh"}}></iframe>     
                        </div>
                    )    
                }else{
                    return(
                        <div id="rmProof" >
                            <p style={{textAlign:"center"}}>Click the link below to view the proof of your ad in a new window.</p>
                            <p style={{textAlign:"center"}}>You must return to this window to submit corrections or approve your proof</p>
                            <p style={{textAlign:"center"}}><Button type="button" id="rmProofLink" themeColor={"primary"} onClick={openRMProof}>Click here to view this proof in a new window</Button></p>
                        </div>
                    )    
                }
        }
    }
    
    useEffect(()=>{
        const element=pageContext?.selectedAd.element;
        if (element){
            getAnnotations(element,"0").then(data=>{
                setAnnotations(data);
            });;
        }
        const resizeProof=()=>{
            console.log("Window Reszied");
            var img = document.getElementsByClassName("noteImage")[0];
            var noteList = document.getElementsByClassName("noteList")[0];
            if (img) {
                console.log(img);
                (img as HTMLElement).style.height = `${window.innerHeight - 20}px`;
            }else{
                console.log("Image Not Found");
            }
            if (noteList){
                (noteList as HTMLElement).style.height = `${window.innerHeight - 20}px`;
            }
        }
        resizeProof();
        window.addEventListener('resize',resizeProof);
        return ()=>{
            //Handle upload actions
            console.log("Proof unloaded");
        }
    },[])

    return(
        
        <div>
            <ProofNotesList></ProofNotesList>
            <DisplayFields/>
            {getProof()}
        </div>
    ) 
}